import { Check } from 'lucide-react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth/auth'
import { Logo } from '@/app/shell/Logo'

export function LoginPage() {
  const { signInEntra, configured, isAuthenticated } = useAuth()

  // After the Entra redirect, MSAL returns to the page sign-in was launched from
  // (this /login route). Once authenticated, bounce straight into the app instead
  // of re-showing the login screen.
  if (isAuthenticated) return <Navigate to="/home" replace />

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[1.05fr_0.95fr]">
      {/* brand side */}
      <div className="relative hidden flex-col justify-between overflow-hidden p-16 md:flex">
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(70% 120% at 18% 24%, rgba(50,105,175,.55), transparent 60%),' +
              'radial-gradient(80% 120% at 88% 82%, rgba(249,56,4,.5), transparent 55%),' +
              'radial-gradient(120% 100% at 50% 0%, rgba(108,140,200,.22), transparent 60%), #050B15',
          }}
        />
        <div className="relative text-white">
          <Logo className="h-[18px] w-auto" />
        </div>
        <div className="relative">
          <div className="font-display text-[11px] font-medium uppercase tracking-[0.2em] text-[#9FB4D2]">
            Explosion-risk underwriting
          </div>
          <h1 className="mt-3 max-w-[15ch] text-[46px] font-bold leading-[1.02] text-white">
            The language of managed risk.
          </h1>
          <p className="mt-4 max-w-[44ch] text-[#C6D4E8]">
            Evidence-first assessment and underwriting for battery storage and petrochemical sites.
            Every number traces to its proof.
          </p>
        </div>
        <div className="relative text-xs text-[#5B7091]">Lloyd&rsquo;s Lab · Howden — demonstration environment</div>
      </div>

      {/* form side */}
      <div className="flex items-center justify-center bg-background p-10">
        <div className="w-full max-w-sm">
          <h2 className="text-[22px] font-semibold">Sign in</h2>
          <p className="mb-6 mt-1.5 text-sm text-muted-foreground">
            Use your organisation account to continue. You can switch roles once signed in.
          </p>

          <button
            onClick={signInEntra}
            disabled={!configured}
            className="flex h-11 w-full items-center justify-center gap-3 rounded-md border border-input bg-surface text-[14.5px] font-semibold hover:bg-surface-2 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <span className="grid size-[18px] grid-cols-2 gap-px">
              <i className="bg-[#F25022]" />
              <i className="bg-[#7FBA00]" />
              <i className="bg-[#00A4EF]" />
              <i className="bg-[#FFB900]" />
            </span>
            Continue with Microsoft
          </button>
          {!configured && (
            <p className="mt-2 text-center text-[11px] text-flare">
              Authentication is not configured in this environment.
            </p>
          )}

          <div className="mt-6 flex items-center justify-center gap-2 text-[11px] text-faint">
            <Check className="size-3.5 text-stable" /> secured by Azure Entra ID
          </div>
        </div>
      </div>
    </div>
  )
}
